const Animal = {
    animal: {
        animal: 'Animal',
        animals: 'Animals',
        add: 'Add animal',
        first: 'You have not added any animal yet, please add some animals to start.',
        mother: 'Mother',
        father: 'Father',
        name: 'Name',
        owner: 'Owner',
        description: 'Description',
        birthDate: 'Birth date',
        age: 'Age',
        externalId: 'Official registration number',
        internalId: 'Identifier (name, alias, reference, ...) ',
        land: 'Land',
        datas: {
            title: 'State of the animal'
        },
        gender: 'Gender',
        genders: {
            male: 'Male',
            female: 'Female',
            males: 'Males',
            females: 'Females'
        },
        deliver: 'deliver',
        delivers: {
            first: 'First deliver',
            analisys: 'Deliver analisys',
            average: 'A deliver every {{days}} days',
            table: 'Deliver table',
            graphic: 'Deliver Chart'
        },
        health: 'Health',
        healthy: {
            title: 'Healthy',
            data: 'Healthy data',
            vaccines: 'Vaccines',
            diseases: 'Diseases',
            diseasesTable: 'Diseases table',
            veterinary: 'Veterinary'
        },
        children: 'Pup',
        childrens: {
            title: 'Pups',
            amount: 'Amount'
        },
        type: 'Type',
        types: {
            adult: 'Adult',
            child: 'Breeding',
            group: 'Litter'
        },
        specie: 'Specie',
        species: {
            bovine: 'Bovine',
            goat: 'Goat',
            equine: 'Equine',
            ovine: 'Ovine',
            porcine: 'porcine',
            canine: 'canine'
        },
        state: 'State',
        states: {
            pregnancy: 'Pregnancy',
            breeding: 'Breeding',
            maintenance: 'Maintenance',
            growing: 'Growing',
            fattening: 'Fattening',
            ready: 'Ready',
            sold: 'Sold'
        },
        bovine: {
            adult: {
                male: 'Bull',
                female: 'Cow'
            },
            child: {
                male: 'Calf',
                female: 'Veal'
            }
        },
        porcine: {
            adult: {
                male: 'Hog',
                female: 'Sow'
            },
            group: {
                default: 'Pig',
                male: 'Pig',
                female: 'Pig'
            }
        }
    }
};

export default Animal;
